export const getRandomColor = (alpha = 1): string =>
  `rgba(${Math.round(Math.random() * 255)},${Math.round(Math.random() * 255)},${Math.round(
    Math.random() * 255,
  )},${alpha})`;
